import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import MemberGroupListTable from '../MemberGroupListTable'
import { GetMemberGroupTableData } from '@/modules/manage-member/type'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { PlusIcon } from 'lucide-react'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'

interface MemberGroupListListingProps {
	data: GetMemberGroupTableData[]
	total: number
	isLoading?: boolean
}

export default function MemberGroupListListing({
	data,
	total,
	isLoading,
}: MemberGroupListListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_OPERATOR,
	)

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`รายชื่อประเภทผู้ดูแลระบบทั้งหมด`}
					description="รายชื่อประเภทผู้ดูแลระบบทั้งหมด"
				/>
				{hasWritePermission && (
					<Button asChild variant="default">
						<Link to="/operator/member-group-list/create-group">
							<PlusIcon className="h-4 w-4" />
							สร้างประเภทผู้ดูแลระบบ
						</Link>
					</Button>
				)}
			</div>
			<Separator />
			<MemberGroupListTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
